// Achado de revisão (IMPORTANTE, PR #1061): reativar() era praticamente idêntico
// em Contatos.vue/CCEE.vue/PontosMedicao.vue (confirmação -> chamada -> toast ->
// reload), mas as três cópias já haviam divergido em detalhes (loading, presença
// de requestEntity no erro). O consumidor precisa de `this.service`,
// `this.requestEntity`, `this.getByEmpresa()` e `this.loading` (bind de
// `v-async`), já presentes nos três formulários via CRUDTemplate.
export default {
  methods: {
    mxReativarSubDado({ id, confirmMessage, successMessage }) {
      return this.mxToggleWarningModal(confirmMessage)
        .then(() => {
          const { empresaId } = this.$parent;
          const requisicao = this.service
            .reativar({ id }, empresaId)
            .then(() => {
              this.mxToggleToast(successMessage);
              this.getByEmpresa();
            })
            .catch((error) =>
              this.mxHandleRequestError(error, this.requestEntity)
            );
          this.loading = requisicao;
          return requisicao;
        })
        .catch(() => {});
    },
  },
};
